<template>
  <div>
    <el-dialog width="70%" top="0px" @close="close" title="干系人" :visible.sync="dialogVisible" append-to-body>
      <SideTagsStakeholder :isMonitor="true" ref="SideTagsStakeholder"></SideTagsStakeholder>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import emitEx from '@/util/emitEx.js';
  import SideTagsStakeholder from "../components/SideTagsStakeholder.vue";
  export default {
    components: {
      SideTagsStakeholder
    },
    data() {
      return {
        dialogVisible: false
      };
    },
    methods: {
      close(){//关闭
        this.$emit('getValue',$refs.SideTagsStakeholder.StakeholderList)
      },
      OpenDialog(StakeholderList) {
        console.log('StakeholderList',StakeholderList);
        let _this = this;
        this.dialogVisible = true;
        setTimeout(function() {
          _this.$refs.SideTagsStakeholder.StakeholderList=StakeholderList;
        }, 1000);
      },
      close() {
        this.dialogVisible = false;
        emitEx.$emit('getStart');
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>
